<template>
  <div data-testid="page-error-not-found">
    <h1>Oops!</h1>
    <h3>{{ t('ErrorViews.ErrorNotFound.message') }}</h3>
    <RouterLink :to="{ name: 'root' }">
      {{ t('ErrorViews.linkToRootLabel') }}
    </RouterLink>
  </div>
</template>

<script lang="ts">
export default { name: 'ErrorNotFound' }
</script>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
